import { cva } from 'class-variance-authority'

export const checkboxCardVariants = cva(
  "inline-flex items-center justify-start gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground active:opacity-60 disabled:pointer-events-none disabled:opacity-50 data-[state=checked]:border-primary [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap cursor-pointer",
  {
    variants: {
      variant: {
        default: 'bg-transparent border border-border',
        outline:
          'border border-border bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground'
      },
      size: {
        default: 'min-w-9',
        sm: 'min-w-8',
        lg: 'min-w-10'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)
